import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Section } from '../../legacy/hui/src/styled';
import styled from 'styled-components';
import logo from '../images/bunnings-logo.svg';
import logoSmall from '../images/bunnings-logo-small.svg';
import PropTypes from 'prop-types';

export const SectionBunnings = Section.extend`
  background-color: #0d5257;
  height: 50px;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    height: 100px;
  }
`;

export const SectionTop = Section.extend`
  background-color: #07464a;
  height: 0;
  border-bottom: 1px solid #106b72;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    height: 34px;
  }
`;

export const SectionTopLinkWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0;
  height: 34px;
`;

export const SectionTopLink = styled(Link)`
  color: #ffffff;
  display: inline-block;
  font-size: 12px;
  line-height: 18px;
  text-decoration: none;
  cursor: pointer;
`;

export const MenuLink = styled.a`
  padding: 10px 15px 10px 2px;
  display: inline-block;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    padding: 20px 25px 15px 5px;
  }
`;

export const Logo = styled.div`
  width: 86px;
  height: 27px;
  background: url(${logoSmall}) no-repeat;
  text-indent: -99999px;
  display: inline-block;
  background-size: contain;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    background: url(${logo}) no-repeat;
    width: 183px;
    height: 58px;
    background-size: contain;
  }
`;

export const HeaderTextWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 0;
  height: 50px;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    height: 100px;
  }
`;

export const HeaderText = styled.div`
  color: #fff;
  display: inline-block;
  font-size: 13px;
  line-height: 20px;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    font-size: 20px;
    line-height: 26px;
  }
`;

export const HeaderPhone = styled.div`
  color: #fff;
  display: inline-block;
  font-size: 13px;
  line-height: 20px;
  padding-left: 5px;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    font-size: 20px;
    line-height: 26px;
    padding-left: 20px;
  }
`;

export class HeaderBunnings extends Component {
  static propTypes = {
    siteSource: PropTypes.string,
    path: PropTypes.string
  };

  render() {
    const { siteSource, path } = this.props;

    return (
      <div>
        <SectionTop>
          <Container>
            <Row>
              <Col xs={0} md={12}>
                {path !== '/error' && (
                  <SectionTopLinkWrapper>
                    {path !== '/install' && (
                      <SectionTopLink
                        to="/install"
                        rel="noopener noreferrer"
                        data-ga-category={siteSource}
                        data-ga-action={`${siteSource} - Clicked Back to Main Site`}
                        data-ga-label={`${siteSource} - Clicked Back to Main Site`}
                      >
                        ← Back to installations
                      </SectionTopLink>
                    )}
                  </SectionTopLinkWrapper>
                )}
              </Col>
            </Row>
          </Container>
        </SectionTop>
        <SectionBunnings>
          <Container>
            <Row>
              <Col xs={6} md={8}>
                <MenuLink
                  href="https://www.bunnings.com.au/"
                  rel="noopener noreferrer"
                  data-ga-category={siteSource}
                  data-ga-action={`${siteSource} - Clicked Home`}
                  data-ga-label={`${siteSource} - Clicked Home`}
                >
                  <Logo />
                </MenuLink>
              </Col>
              <Col xs={6} md={4} style={{ textAlign: 'right' }}>
                <HeaderTextWrapper>
                  <HeaderText>Need help?</HeaderText>
                  <HeaderPhone>
                    1300 <span>043</span> 520
                  </HeaderPhone>
                </HeaderTextWrapper>
              </Col>
            </Row>
          </Container>
        </SectionBunnings>
      </div>
    );
  }
}
